// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cQBRW","name":"styles_name__vq9QU","phone":"styles_phone__1njGI"};